import React from "react";
import { motion } from "framer-motion";
const PricingSection = () => {
  const pricingData = [
    {
      package: "P-1",
      customers: "100",
      otc: "4,000 TK",
      standardMonthlyFee: "600 TK",
      premiumMonthlyFee: "800 TK",
      olt: 1,
    },
    {
      package: "P-2",
      customers: "200",
      otc: "4,000 TK",
      standardMonthlyFee: "1,000 TK",
      premiumMonthlyFee: "1,200 TK",
      olt: 1,
    },
    {
      package: "P-3",
      customers: "300",
      otc: "4,000 TK",
      standardMonthlyFee: "1,300 TK",
      premiumMonthlyFee: "1,500 TK",
      olt: 2,
    },
    {
      package: "P-4",
      customers: "400",
      otc: "4,000 TK",
      standardMonthlyFee: "1,700 TK",
      premiumMonthlyFee: "1,800 TK",
      olt: 3,
    },
    {
      package: "P-5",
      customers: "500",
      otc: "6,000 TK",
      standardMonthlyFee: "2,000 TK",
      premiumMonthlyFee: "2,200 TK",
      olt: 3,
    },
    {
      package: "P-6",
      customers: "600",
      otc: "6,000 TK",
      standardMonthlyFee: "2,400 TK",
      premiumMonthlyFee: "2,400 TK",
      olt: 5,
    },
    {
      package: "P-7",
      customers: "800",
      otc: "6,000 TK",
      standardMonthlyFee: "2,600 TK",
      premiumMonthlyFee: "3,000 TK",
      olt: 5,
    },
    {
      package: "P-8",
      customers: "1,000",
      otc: "6,000 TK",
      standardMonthlyFee: "3,000 TK",
      premiumMonthlyFee: "3,500 TK",
      olt: 6,
    },
    {
      package: "P-9",
      customers: "1,300",
      otc: "10,000 TK",
      standardMonthlyFee: "3,500 TK",
      premiumMonthlyFee: "4,000 TK",
      olt: 6,
    },
    {
      package: "P-10",
      customers: "1,500",
      otc: "10,000 TK",
      standardMonthlyFee: "4,000 TK",
      premiumMonthlyFee: "4,500 TK",
      olt: 7,
    },
    {
      package: "P-11",
      customers: "2,000",
      otc: "10,000 TK",
      standardMonthlyFee: "5,000 TK",
      premiumMonthlyFee: "5,000 TK",
      olt: 8,
    },
    {
      package: "P-12",
      customers: "3,000",
      otc: "10,000 TK",
      standardMonthlyFee: "6,500 TK",
      premiumMonthlyFee: "6,500 TK",
      olt: 10,
    },
    {
      package: "P-13",
      customers: "5,000",
      otc: "10,000 TK",
      standardMonthlyFee: "9,000 TK",
      premiumMonthlyFee: "9,000 TK",
      olt: 12,
    },
  ];
  return (
    <section
      className="md:mt-5 mt-0 md:w-5/6 md:px-0 px-2 mx-auto"
      id="pricing"
    >
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-700">
            Great Pricing Plans
          </h2>
          <div className="bg-fuchsia-600 w-24 md:w-32 h-1 mt-2 mx-auto"></div>
          <p className="text-base md:text-lg text-gray-600 mt-4">
            We have some exciting packages and plans for you.
          </p>
        </div>

        {/* Table */}
        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.1, ease: "easeOut" }}
          className="rounded-lg overflow-hidden"
        >
          <table className="min-w-full text-left">
            <thead className="bg-indigo-700 text-white">
              <tr>
                <th
                  rowSpan="2"
                  className="py-1 px-1 text-center border border-white"
                >
                  Package
                </th>
                <th
                  rowSpan="2"
                  className="py-1 px-1 text-center border border-white"
                >
                  Customer Limit
                </th>
                <th
                  rowSpan="2"
                  className="py-1 px-1 text-center border border border-white"
                >
                  OTC Charge
                </th>

                {/* OLT single column header */}
                <th
                  rowSpan="2"
                  className="py-1 px-1 text-center border border-white   w-38"
                >
                  Standard Monthly Fee
                </th>
                {/* Monthly Fee main header */}
                <th
                  colSpan="2"
                  className="py-1 px-1 text-center border border border-white"
                >
                  Premium
                </th>
              </tr>

              {/* Sub-headers for Monthly Fee only */}
              <tr>
                <th className="py-1 px-1 text-center border border-white">
                  Monthly Fee
                </th>
                <th className="py-1 px-1 text-center border border-white">
                  OLT Limit
                </th>
              </tr>
            </thead>

            <tbody>
              {pricingData.map((row, index) => (
                <motion.tr
                  key={String(row.package) + "-" + String(index)}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.1,
                    delay: 0.05 * index,
                    ease: "easeOut",
                  }}
                  className="text-black border border-gray-200 hover:bg-gray-100"
                >
                  <td className="py-1 px-1 text-center font-extrabold ">
                    {row.package}
                  </td>
                  <td className="py-1 px-1 text-center">{row.customers}</td>
                  <td className="py-1 px-1 text-center">{row.otc}</td>

                  {/* Standard Monthly Fee */}
                  <td className="py-1 px-1 text-center">
                    {row.standardMonthlyFee}
                  </td>

                  {/* Premium Monthly Fee */}
                  <td className="py-1 px-1 text-center text-fuchsia-600 font-bold">
                    {row.premiumMonthlyFee}
                  </td>

                  {/* Single OLT column */}
                  <td className="py-1 px-1 text-center text-fuchsia-600 font-bold">
                    {row.olt}
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingSection;
